import { render, staticRenderFns } from "./AddTrendChartModal.vue?vue&type=template&id=b449fa2a&scoped=true&lang=html"
import script from "./AddTrendChartModal.vue?vue&type=script&lang=js"
export * from "./AddTrendChartModal.vue?vue&type=script&lang=js"
import style0 from "./AddTrendChartModal.vue?vue&type=style&index=0&id=b449fa2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b449fa2a",
  null
  
)

export default component.exports